import { apiClient, type ApiClientResponse, routes } from 'common/services';
import { type CommunityDataObject } from 'models/service';

export const getCommunity = async ({ id, invitationToken }: { id: string; invitationToken?: string }) => {
  return apiClient.get<CommunityDataObject, ApiClientResponse<CommunityDataObject>>(routes.community.get(id), {
    params: { invitation_token: invitationToken },
  });
};
